import { useLocation } from 'react-router-dom';
import UserListView from '../components/users/UserListView';
import UserFormView from '../components/users/UserFormView';

export interface UsersPageProps {
	createPermission?: string;
	editPermission?: string;
	deletePermission?: string;
	resetPasswordPermission?: string;
}

export default function UsersPage({
	createPermission,
	editPermission,
	deletePermission,
	resetPasswordPermission,
}: UsersPageProps = {}) {
	const { pathname } = useLocation();

	// /iam/users exactly → list view
	// /iam/users/create, /iam/users/:id, /iam/users/:id/edit → form view
	if (pathname !== '/iam/users') {
		return (
			<UserFormView
				editPermission={editPermission}
				deletePermission={deletePermission}
				resetPasswordPermission={resetPasswordPermission}
			/>
		);
	}

	return <UserListView createPermission={createPermission} />;
}
